import { ComponentPropsWithoutRef, FC } from 'react';

export type OpenInFullIconProps = ComponentPropsWithoutRef<'svg'>;

export const OpenInFullIcon: FC<OpenInFullIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M2 14V8.85659H2.93453V12.4022L12.4061 2.93453H8.85659V2H14V7.14341H13.0655V3.59392L3.59782 13.0655H7.14341V14H2Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
